import { base44 } from '@/api/base44Client';
import { getNotificationRoute } from '@/lib/notificationRouting';

function normalizeRecipient(recipient = {}) {
  const memberEmail = String(
    recipient.member_email || recipient.memberEmail || recipient.email || ''
  ).trim().toLowerCase();
  const memberId = recipient.member_id || recipient.memberId || recipient.id || null;

  return {
    member_id: memberId || null,
    member_email: memberEmail || null,
  };
}

function compactPushBody(message = '') {
  return String(message)
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 180);
}

function isScheduleReminderType(type) {
  return /_schedule_reminder_(day_before|12h)$/.test(String(type || '').trim());
}

export async function deliverMemberNotification({
  recipients = [],
  title,
  message,
  type = 'general',
  referenceId = null,
  route,
  extraData = {},
}) {
  const normalizedRecipients = recipients
    .map(normalizeRecipient)
    .filter((recipient) => recipient.member_id || recipient.member_email);

  if (!title || !message || normalizedRecipients.length === 0) {
    return { createdCount: 0, pushSent: false };
  }

  const dedupedRecipients = [
    ...new Map(
      normalizedRecipients.map((recipient) => {
        const key = recipient.member_email || String(recipient.member_id);
        return [key, recipient];
      })
    ).values(),
  ];

  const createResults = await Promise.allSettled(
    dedupedRecipients.map((recipient) =>
      base44.entities.Notification.create({
        member_id: recipient.member_id,
        member_email: recipient.member_email,
        title,
        message,
        type,
        reference_id: referenceId,
        is_read: false,
      })
    )
  );

  let pushSent = false;
  if (isScheduleReminderType(type)) {
    return {
      createdCount: createResults.filter((result) => result.status === 'fulfilled').length,
      pushSent,
      pushSkippedReason: 'schedule-reminders-use-edge-function',
    };
  }

  try {
    await base44.integrations.Core.SendPushNotification({
      recipients: dedupedRecipients,
      notification: {
        title,
        body: compactPushBody(message),
        type,
        reference_id: referenceId,
        route: route || getNotificationRoute({ type, reference_id: referenceId }),
        data: extraData,
      },
    });
    pushSent = true;
  } catch (error) {
    console.error('Erro ao enviar push notification:', error);
  }

  return {
    createdCount: createResults.filter((result) => result.status === 'fulfilled').length,
    pushSent,
  };
}
